// Refus de validation ASP.NET ([ApiController]) : { title: "One or more validation errors occurred.", errors: { ClientPhone: ["…"] } }.
// Sans traduction, le front n'affichait que ce titre anglais : impossible de savoir quel champ corriger.

const FIELD_LABELS = {
    clientfirstname: "Prénom",
    firstname: "Prénom",
    clientlastname: "Nom",
    lastname: "Nom",
    clientphone: "Téléphone",
    phone: "Téléphone",
    clientemail: "E-mail",
    email: "E-mail",
    clientaddress: "Adresse",
    address: "Adresse",
    clientbirthdate: "Date de naissance",
    birthdate: "Date de naissance",
    clientbirthplace: "Lieu de naissance",
    birthplace: "Lieu de naissance",
    companyname: "Société",
    siret: "SIRET",
    deliveryaddress: "Adresse de livraison",
    material: "Matériel",
    serviceid: "Service",
    startdate: "Date de début",
    enddate: "Date de fin",
    hour: "Heure de début",
    endhour: "Heure de fin",
    rentalcontacts: "Contacts",
    comment: "Commentaire",
};

// « $.ClientPhone », « RentalContacts[0].Name », « ClientPhone » -> libellé du champ.
function fieldLabel(field) {
    const path = String(field).replace(/^\$\.?/, "");
    const key = path.replace(/\[\d+\]/g, "").split(".")[0].toLowerCase();
    return FIELD_LABELS[key] || path;
}

// Messages par défaut des DataAnnotations / System.Text.Json (en anglais) ; un message déjà en français passe tel quel.
function translateMessage(message) {
    const text = String(message ?? "");
    let match = /maximum length of '(\d+)'/i.exec(text);
    if (match) {
        return `${match[1]} caractères maximum`;
    }
    match = /minimum length of '(\d+)'/i.exec(text);
    if (match) {
        return `${match[1]} caractères minimum`;
    }
    if (/field is required/i.test(text)) {
        return "obligatoire";
    }
    if (/could not be converted|is not valid|is invalid/i.test(text)) {
        return "format invalide";
    }
    return text;
}

export function formatValidationErrors(errors) {
    if (!errors || typeof errors !== "object" || Array.isArray(errors)) {
        return null;
    }

    let entries = Object.entries(errors).filter(([, messages]) => Array.isArray(messages) && messages.length > 0);
    // Corps JSON illisible : ASP.NET ajoute aussi « le paramètre est requis » sur le DTO entier, sans intérêt pour l'utilisateur.
    if (entries.some(([field]) => field.startsWith("$"))) {
        entries = entries.filter(([field]) => field.startsWith("$"));
    }
    if (entries.length === 0) {
        return null;
    }

    const details = entries.map(([field, messages]) => `${fieldLabel(field)} : ${translateMessage(messages[0])}`);
    return `Enregistrement refusé, vérifiez ${details.length > 1 ? "ces champs" : "ce champ"} — ${details.join(" · ")}`;
}
